import Vue from 'vue'
import * as toastr from 'toastr'
import VueResource from 'vue-resource'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import mixins from '../mixins.js'
import Multiselect from '../../component/dccore-form/multiselect.vue'
import TextInput from '../../component/dccore-form/textInput.vue'
import NumberInput from '../../component/dccore-form/numberInput.vue'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'
import axios from 'axios'
import SimpleSingleselect from '../../component/simple-form/singleselect.vue'
import QuickWarehouseShift from '../../component/view/QuickWarehouseShift.vue'
import SingleSelect from '@component/singleselect.vue'

if ($('#warehouse_work_order_new_form').length) {
  Vue.use(VueResource)

  new Vue({
    el: '#warehouse_work_order_new_form',
    delimiters: ['[[', ']]'],
    components: {
      RingLoader,
      TextInput,
      NumberInput,
      SimpleSingleselect,
      Multiselect,
      Datepicker,
      moment,
      QuickWarehouseShift,
      SingleSelect,
    },
    mixins: [mixins],
    data: {
      generatingForTemporary: false,
      loading: 0,
      quickShiftCounter: 0,
      quickLoading: 0,
      date: moment().toDate(),
      generationDate: moment().subtract(1, 'days').toDate(),
      teams: [],
      assignedMeals: [],
      hours: [],
      caretDownClass: 'fa-caret-down',
      caretUpClass: 'fa-caret-up',
      visibleTeams: [],
      pendingAssignations: {},
      assignTeamColors: {},
      teamCounters: {},
      teamCountersText: {},
      quickShifts: [],
      warehouses: [],
      materials: [],
      materialsNotFiltered: [],
      generatedShifts: [],
      errors: [],
      checkedAssignedMeals: [],
      checkedAssignedMaterials: [],
      selectTeam: null,
      collectionTeams: [],
      selectedTeam: null,
      isCheckedAll: false,
      assignedMaterials: [],
      filterFromHour: null,
      filterToHour: null,
    },
    computed: {
      allMaterials: function() {
        let materials = []

        this.assignedMeals.forEach((_meal) => {
          _meal.materials.forEach((_material) => {
            materials.push(_material)
          })
        })

        return materials
      },
    },
    watch: {
      loading: {
        handler: function (newLoading, oldLoading) {
          if (newLoading === 0 && oldLoading > 0) {
            $(document).ready(() => {
              $('.to-show').show()
            })
          }
        }
      },
      selectedTeam: function () {
        this.isCheckedAll = false
        this.checkAll()
      }
    },
    mounted: function () {
      this.createHours()
      this.getTeams()
    },
    methods: {
      closeSummaryModal: function () {
        $('#summaryModal').modal('hide')
        this.generatedShifts = []
      },
      showSummaryModal: function () {
        $('#summaryModal').modal()
      },
      closeErrorModal: function () {
        $('#errorModal').modal('hide')
        this.errors = []
      },
      showErrorModal: function () {
        $('#errorModal').modal()
      },
      createHours: function () {
        let hours = [...Array(24).keys()]
        hours.forEach((hour) => {
          var hourString = hour.toString()+':00'
          if (hour.toString().length < 2) {
            hourString = `0${hour}:00`
          }
          this.hours.push({
            'id': hour,
            'name': hourString,
          })
        })
      },
      fetchTeams: function (date, id, fromHour, toHour) {
        this.setInitialState()
        this.loading += 2
        let dateFormatted = moment.utc(date).format('Y-M-D')

        let assignedTeamsUrl = Routing.generate('api_get_assign_teams_new', {
          date: dateFormatted,
          teamId: id,
        })

        let teamsUrl = Routing.generate('api_get_team', { id: id })
        axios.get(teamsUrl).then((response) => {
          this.teams = response.data
          this.loading--
        })
        axios.get(assignedTeamsUrl, {
          params: {
            fromHour: fromHour,
            toHour: toHour,
          }
        }).then((response) => {
          this.assignedMeals = response.data
          this.teamCounters = {
            selected: 0,
            all: 0,
          }

          if (this.assignedMeals.length === 0) {
            toastr.info(
              'Nie znaleziono posiłków przypisanych do zeposłu.',
              null,
              { timeOut: 5000 }
            )
          }
          this.loading--
        })
      },
      checkAssignedMeal: function (assignedMealId, check) {
        if (check) {
          this.checkedAssignedMeals.push(assignedMealId)
          this.allMaterials.forEach(material => {
            if (material.parent_meal_id === assignedMealId) {
              this.checkedAssignedMaterials.push(material.uid)
            }
          })
        } else {
          this.checkedAssignedMeals = this.checkedAssignedMeals.filter(el => el !== assignedMealId)
          this.allMaterials.forEach(material => {
            if (material.parent_meal_id === assignedMealId) {
              this.checkedAssignedMaterials = this.checkedAssignedMaterials.filter(el => el !== material.uid)
            }
          })
        }

        this.assignedMeals.forEach(meal => {
          if (assignedMealId === meal.meal.source_id) {
            this.checkAssignedMeal(meal.meal.id, check)
          }
        })
      },
      checkAssignedMaterial: function(uid, check) {
        if (check) {
          this.checkedAssignedMaterials.push(uid)
        } else {
          this.checkedAssignedMaterials = this.checkedAssignedMaterials.filter(el => el !== uid)
        }
      },
      generateMaterialAssembleList: function (isMerge) {
        this.errors = []
        this.loading++

        if (this.checkedAssignedMaterials.length === 0) {
          toastr.info('Nie wybrano żadnego składnika')
          this.loading--
          return
        }

        let materials = []
        this.allMaterials.forEach(material => {
          this.checkedAssignedMaterials.forEach(key => {
            if (key === material.uid) {
              materials.push(material)
            }
          })
        })

        const data = {
          teamId: this.teams.id,
          materials: materials,
          productionDate: moment.utc(this.date).format('YYYY-MM-DD'),
          isMerge: isMerge,
          fromHour: this.filterFromHour,
          toHour: this.filterToHour,
        }

        this.$http.post(
          Routing.generate('api_generate_material_assemble_list_new'),
          data,
          {
            responseType: 'blob'
          }
        ).then(response => {
          window.open(URL.createObjectURL(response.data))
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      checkAll() {
        this.assignedMeals.forEach((assignedMeal) => {
          this.checkAssignedMeal(assignedMeal.meal.id, this.isCheckedAll)
        })
      },
      showAssignTeam() {
        if (this.selectedTeam) {
          this.fetchTeams(this.date, this.selectedTeam, this.filterFromHour, this.filterToHour)
        } else {
          toastr.error('Nie wybrano zespołu.')
        }
      },
      getTeams() {
        this.loading++
        let url = Routing.generate('api_get_active_production_teams', { context: 'dropdown' })
        this.$http.get(url).then(response => {
          this.collectionTeams = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
      setInitialState: function () {
        this.teams = []
        this.assignedMeals = []
        this.checkedAssignedMeals = []
        this.checkedAssignedMaterials = []
      },
    }
  })
}
